import { Component, Input } from '@angular/core';
import { BreadcrumbItem } from './breadcrumbs.types';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false
})
export class BreadcrumbsComponent {
  /**
   * The current location of the user in the breadcrumb trail, should match the breadcrumb key.
   */
  @Input() currentPath!: string;
  /**
   * A list of breadcrumbs to show in the component.
   */
  @Input() links: BreadcrumbItem[] = [];

  /**
   * Whether to truncate the breadcrumb text if it exceeds the available space.
   * Truncates only the last item in the breadcrumb trail.
   * Defaults to false.
   */
  @Input() truncate: boolean = false;

  divider = '/';
}
